import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { routes } from "../routes";
import { connect } from "react-redux";
import { IApplicationState } from "../../redux/reducers";
import DeveloperPortalLogin from "./DeveloperPortalLogin";
import DeveloperPortalSignup from "./DeveloperPortalSignup";

interface IProps {
  isLoggedIn: boolean;
}

const DeveloperPortalAuth: React.FC<IProps> = ({ isLoggedIn }) => {
  // If already logged in, redirect to developer portal dashboard
  if (isLoggedIn) {
    return <Redirect to={routes.DEVELOPER_PORTAL_DASHBOARD} />;
  }

  return (
    <Switch>
      <Route exact path={routes.DEVELOPER_PORTAL_LOGIN} component={DeveloperPortalLogin} />
      <Route exact path={routes.DEVELOPER_PORTAL_SIGNUP} component={DeveloperPortalSignup} />
      <Redirect exact from="/developer-portal" to={routes.DEVELOPER_PORTAL_LOGIN} />
    </Switch>
  );
};

const mapStateToProps = (state: IApplicationState) => ({
  isLoggedIn: state.user.isLoggedIn,
});

export default connect(mapStateToProps)(DeveloperPortalAuth);
